
import { CustomCanvas } from "@/types/fabric";
import { Tool } from "./use-canvas-setup";

interface UseDrawingHandlersProps {
  canvas: CustomCanvas | null;
  handleLoadDrawing: (data: string, id: string, analysisData?: any) => void;
  setCurrentDrawingId: (id: string | null) => void;
  setProjectTitle: (title: string) => void;
  clearCanvas: () => void;
  resetAnalysis?: () => void;
}

export const useDrawingHandlers = ({
  canvas,
  handleLoadDrawing,
  setCurrentDrawingId,
  setProjectTitle,
  clearCanvas,
  resetAnalysis,
}: UseDrawingHandlersProps) => {
  const handleDrawingLoad = (drawingData: string, drawingId: string, analysisData?: any) => {
    console.log('Loading drawing with analysis:', { drawingId, analysisData });
    
    // First reset any existing analysis
    if (resetAnalysis) {
      console.log('Resetting analysis before loading drawing');
      resetAnalysis();
    }
    
    // Track drawing version and ensure it's preserved
    try {
      const data = JSON.parse(drawingData);
      console.log('Parsed drawing data version:', data.version);
      
      // Mark canvas as having a loaded drawing from history
      if (canvas) {
        // Make sure to use only properties defined in CanvasData
        canvas.data = {
          ...canvas.data,
          currentDrawingId: drawingId,
          version: data.version || 1,
          isModified: false
        };
      }
    } catch (e) {
      console.warn('Could not parse drawing data to check version:', e);
    }
    
    // Then load the drawing
    handleLoadDrawing(drawingData, drawingId, analysisData);
  };

  const handleClearCanvas = () => {
    console.log('handleClearCanvas called in use-drawing-handlers');
    
    try {
      // Clear canvas first - ensure this is properly called
      if (typeof clearCanvas === 'function') {
        console.log('Calling clearCanvas function directly');
        clearCanvas();
        
        // Reset drawing ID and title
        setCurrentDrawingId(null);
        setProjectTitle("Untitled Project");
        
        // Reset analysis state when clearing canvas
        if (resetAnalysis) {
          console.log('Resetting analysis when clearing canvas');
          resetAnalysis();
        }
        
        // Reset canvas data state - using only proper CanvasData properties
        if (canvas) {
          canvas.data = {
            ...canvas.data,
            currentDrawingId: null,
            version: 1,
            isModified: false
          };
        }
      } else {
        console.error('clearCanvas is not a function:', clearCanvas);
      }
    } catch (error) {
      console.error('Error in handleClearCanvas:', error);
    }
  };

  const handleToolToggle = (tool: string) => {
    return tool as Tool;
  };

  return {
    handleDrawingLoad,
    handleClearCanvas,
    handleToolToggle,
  };
};
